import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaGooglePlay,
  FaApple,
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
} from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import Logo from "../../assets/images/logo.png";
import "./HomeFooter.css";

export const HomeFooter = () => {
  return (
    <footer className="px-4">
      {/* Brand + App Links */}
      <Col md={3}>
        <div className="footer-brand">
          <img
            src={Logo}
            alt="All Home Desire"
            className="footer-logo mb-3"
          />
          <div className="store-buttons d-flex flex-wrap gap-2">
            <a href="#" className="store-btn">
              <FaGooglePlay /> Google Play
            </a>
            <a href="#" className="store-btn">
              <FaApple /> App Store
            </a>
          </div>
        </div>
      </Col>

      {/* Quick Links */}
      <Col md={3}>
        <h5 className="footer-title">Quick Links</h5>
        <ul className="footer-links">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/property-list">Properties</Link>
          </li>
          <li>
            <Link to="/interiordesign">Interior Design</Link>
          </li>
          <li>
            <Link to="/about-us">About Us</Link>
          </li>
          <li>
            <Link to="/contactus">Contact Us</Link>
          </li>
          <li>
            <Link to="/Policy">Policy</Link>
          </li>
          <li>
            <Link to="/partnerreg">Become Partner</Link>
          </li>
        </ul>
      </Col>

      {/* Contact Info */}
      <Col md={3}>
        <h5 className="footer-title">Contact Info</h5>
        <ul className="footer-contact">
          <li>
            <FaMapMarkerAlt /> 7th Avenue Gaur City 1, Noida Extension
          </li>
          <li>
            <FaPhoneAlt /> +91 9818961783
          </li>
          <li>
            <FaEnvelope /> support@allhomedesire.com
          </li>
        </ul>
        <div className="social-icons d-flex gap-3 mt-4">
          <a href="https://www.facebook.com/allhomedesire/" aria-label="Facebook">
            <FaFacebookF />
          </a>
          <a href="https://www.instagram.com/allhomedesire/" aria-label="Instagram">
            <FaInstagram />
          </a>
          <a href="https://x.com/ushmainfotech" aria-label="Twitter">
            <FaXTwitter />
          </a>
          <a href="https://www.linkedin.com/company/ushma-infotech/posts/?feedView=all" aria-label="LinkedIn">
            <FaLinkedinIn />
          </a>
        </div>
      </Col>
    </footer>
  );
};

export default HomeFooter;
